import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSGenericService {
    static getAllGenerics(pharmacyId, data) {
        return axios.get(`${URL.GET_ALL_PHARMACY_GENERICS}/${pharmacyId}`, {
            ...PMSGenericService.getAuthHeader(),
            params: data
        });
    }

    static getGenericById(id, pharmacyId) {
        return axios.get(`${URL.GET_PHARMACY_GENERIC_BY_ID}/${id}/${pharmacyId}`, PMSGenericService.getAuthHeader());
    }

    static addGeneric(data, pharmacyId) {
        return axios.post(`${URL.POST_PHARMACY_GENERIC}/${pharmacyId}`, data, PMSGenericService.getAuthHeader());
    }

    static updateGeneric(data, id, pharmacyId) {
        return axios.put(`${URL.UPDATE_PHARMACY_GENERIC}/${id}/${pharmacyId}`, data, PMSGenericService.getAuthHeader());
    }

    static deleteGeneric(id, pharmacyId) {
        return axios.delete(`${URL.DELETE_PHARMACY_GENERIC}/${id}/${pharmacyId}`, PMSGenericService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

}
